import React, { createContext, useContext, useState, useEffect } from 'react';

const defaultData = {
  gym: {
    name: 'Gym Arena',
    tagline: 'Where Champions Are Built.',
    heroSubtitle: '8,500 Sq. Ft. of world-class fitness — powered by the industry finest equipment. Your transformation starts here.',
    phone: '+91 XXXXX XXXXX',
    email: '1ms19cs146@gmail.com',
    address: 'Your Gym Address Here, City, State - PIN Code',
    hoursWeekday: 'Mon - Sat: 5:30 AM to 10:00 PM',
    hoursSunday: 'Sunday: 7:00 AM to 8:00 PM',
    area: '8,500',
    totalMembers: '500+',
    totalTrainers: '10+',
    totalBrands: '7+',
    mapUrl: 'https://maps.google.com/maps?q=gym+arena&output=embed&z=15',
    googleReviewUrl: 'https://maps.google.com',
    googleRating: '4.9',
  },
  about: {
    para1: 'Gym Arenaa is more than just a gym — it is a community built around the passion for fitness, discipline, and transformation. Spread across a massive 8,500 square feet, our facility is designed to give every member a premium training experience unlike anything else in the city.',
    para2: 'We believe that great equipment, expert coaching, and the right environment are the three pillars of real progress. That is why we have invested in the finest machines from brands like Hammer Strength, Hoist, Life Fitness, FreeMotion, Paramount, and Assault Fitness — paired with a world-class Bose Music system to keep your energy high.',
    para3: 'From beginners taking their first steps to competitive athletes pushing their limits, Gym Arena welcomes everyone. Our dedicated team of certified trainers is always on the floor to guide, motivate, and push you toward the best version of yourself.',
    image1: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=700&q=80',
    image2: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=400&q=80',
  },
  gallery: [
    { src: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&q=80', label: 'Weight Floor', size: 'large' },
    { src: 'https://images.unsplash.com/photo-1558611848-73f7eb4001a1?w=600&q=80', label: 'Cardio Zone', size: 'small' },
    { src: 'https://images.unsplash.com/photo-1534258936925-c58bed479fcb?w=600&q=80', label: 'Free Weights', size: 'small' },
    { src: 'https://images.unsplash.com/photo-1593079831268-3381b0db4a77?w=600&q=80', label: 'Functional Zone', size: 'small' },
    { src: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80', label: 'Training Area', size: 'medium' },
  ],
  equipment: [
    { name: 'Hammer Strength', category: 'Strength Training', icon: '🏋️' },
    { name: 'Hoist', category: 'Selectorized and Cable', icon: '💪' },
    { name: 'Life Fitness', category: 'Cardio and Strength', icon: '🔄' },
    { name: 'FreeMotion', category: 'Cable and Functional', icon: '⚡' },
    { name: 'Paramount', category: 'Multi-Station', icon: '🏆' },
    { name: 'Assault Fitness', category: 'HIIT and Conditioning', icon: '🚀' },
    { name: 'Bose Music', category: 'Premium Audio System', icon: '🎵' },
  ],
  reviews: [
    { 
      name: 'Ansh Rai',
      rating: 5,
      date: 'a month ago',
      text: 'This gym has one of the best atmospheres I’ve trained in. The environment is motivating, positive, and focused — it really pushes you to give your best every day. The equipment is well-maintained and there’s enough variety for all kinds of workouts.The trainers are supportive, knowledgeable, and always make sure members maintain proper form and safety. The overall vibe is energetic and serious about fitness, which makes it a great place for anyone who truly wants to improve themselves.Highly recommended for anyone looking to grow stronger both physically and mentally.',
      avatar: 'AR',
      link: 'https://www.google.com/maps/reviews/@19.008646,73.03497,17z/data=!4m6!14m5!1m4!2m3!1sCi9DQUlRQUNvZENodHljRjlvT21ZM1kydDFUa1U1YnpsNlIyUndSMk5KVkRscE5YYxAB!2m1!1s0x0:0x6f0c1d3b032ea8dc?entry=ttu'
    },
    { 
      name: 'Shivendra Singh',
      rating: 5,
      date: '4 months ago',
      text: 'I joined Gym Arena at 87 kg and today I’m proud to say I’m at 82.8 kg after one month— and this is just the beginning of my journey. The environment here is motivating, clean, and filled with positive energy.A special shoutout to Neha, my trainer, who has been incredibly supportive and disciplined throughout. She understands exactly what works for your body type and makes sure every workout counts. Her guidance, motivation, and consistency are a major reason behind my progress.If you’re someone looking to start or restart your fitness journey, Gym Arena is definitely the right place. Highly recommend! 💪🔥',
      avatar: 'SS',
      link: 'https://www.google.com/maps/reviews/@19.0088996,73.0357359,17z/data=!4m6!14m5!1m4!2m3!1sCi9DQUlRQUNvZENodHljRjlvT25WWlZrVXdkVFp4UWtFdFdsUk1aRGxqY1VzM2IzYxAB!2m1!1s0x0:0x6f0c1d3b032ea8dc?entry=ttu'
    },
    { 
      name: 'Anshul Sharma',
      rating: 5,
      date: '6 months ago',
      text: 'Been working out in this gym since 2020. The trainers are really good and friendly, they always helped me and treated me as a friend. The crowd is also good and everybody is nice and helpful. The gym has variety of equipment helping you target each muscle group in multiple ways. Thank you gym arena for making me part of your family !!',
      avatar: 'AS',
      link: 'https://www.google.com/maps/reviews/@19.0088996,73.0357359,17z/data=!4m6!14m5!1m4!2m3!1sCi9DQUlRQUNvZENodHljRjlvT2pablFuWlRRWHBITUhWd1VrMUNNWEptU1ZkclZVRRAB!2m1!1s0x0:0x6f0c1d3b032ea8dc?entry=ttu'
    },
    { 
      name: 'Ankita Swain',
      rating: 5,
      date: 'a year ago',
      text: 'Gym equipment & environment is very good especially trainers are very supportive here will motivate and better your form . Shiva sir there have motivated me quite well and suggested exercise for betterment. Highly recommend',
      avatar: 'AS',
      link: 'https://www.google.com/maps/reviews/@19.0088996,73.0357359,17z/data=!4m6!14m5!1m4!2m3!1sChZDSUhNMG9nS0VJQ0FnTUN3cG9MUUZnEAE!2m1!1s0x0:0x6f0c1d3b032ea8dc?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D'
    },
    { 
      name: 'Radha Khedkar',
      rating: 5,
      date: '6 months ago',
      text: 'So I have been going to Gym Arena since 2021. It’s been an amazing journey, though at times I am not regular.All the trainers are very helpful, no one has disappointed me ever. Whenever I had any doubts with the forms or workout they were always available for helping me.Shiv has personally helped me a lot over the years. He is really good at training and would anytime recommend him and Gym Arena if you are looking for good results. Trust me this is the best you will get in Belapur!',
      avatar: 'RK',
      link: 'https://www.google.com/maps/reviews/@19.0088996,73.0357359,17z/data=!4m6!14m5!1m4!2m3!1sCi9DQUlRQUNvZENodHljRjlvT2t0M1NFRlNiVlJLWWxGVFdtUXliRUl3YUhod2VHYxAB!2m1!1s0x0:0x6f0c1d3b032ea8dc?entry=ttu'
    },
    { 
      name: 'Anisha Dange',
      rating: 5,
      date: 'a year ago',
      text: 'Gym equipment & environment is very good especially trainers are very supportive here will motivate and better your form . Shiva sir there have motivated me quite well and suggested exercise for betterment. Highly recommend',
      avatar: 'AS',
      link: 'https://www.google.com/maps/reviews/@19.0088996,73.0357359,17z/data=!4m6!14m5!1m4!2m3!1sChZDSUhNMG9nS0VJQ0FnTUN3cG9MUUZnEAE!2m1!1s0x0:0x6f0c1d3b032ea8dc?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D' // fallback
    },
  ],
  features: [
    { icon: '🏆', title: 'World-Class Equipment', desc: 'Every machine sourced from globally trusted brands like Hammer Strength, Life Fitness, and Hoist.' },
    { icon: '🎵', title: 'Premium Atmosphere', desc: 'Train to the beat with our Bose Music system installed throughout the entire facility.' },
    { icon: '💪', title: 'Expert Guidance', desc: 'Our certified trainers are here to guide you every step of the way — from day one to your goals.' },
    { icon: '🔥', title: 'All Fitness Levels', desc: 'Whether you are just starting out or a seasoned athlete, Gym Arena has everything you need.' },
  ],
  membershipPlans: ['Monthly', '3 Months', '6 Months', 'Annual', 'Not Sure Yet'],
};

const GymContext = createContext();

export function GymProvider({ children }) {
  const [data] = useState(defaultData);
  return (
    <GymContext.Provider value={{ data }}>
      {children}
    </GymContext.Provider>
  );
}

export function useGym() {
  return useContext(GymContext);
}